/*
* Broadcast Theme
*/

(function() {
  // Add custom code below this line

  document.addEventListener("DOMContentLoaded", () => {

    const form = document.querySelector('[data-product-form]');

    if (!form) return;

    form.addEventListener("submit", function (event) {

      const selected = document.querySelector(
        'input[name="gift_wrap"]:checked'
      );

      if (!selected) return;

      const variantId = selected.value;

      if (variantId === "") return;

      setTimeout(() => {

        fetch("/cart/add.js", {
          method: "POST",
          headers: {
            "Content-Type": "application/json"
          },
          body: JSON.stringify({
            id: variantId,
            quantity: 1
          })
        });

      }, 700);

    });

  });

 // console.log("custom.js loaded");

})();